import { useContext, useEffect, useMemo } from 'react'

import {
  Box,
  DoughnutChart,
  Icon,
  Text,
  getThemeColor,
} from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { ProviderDashboardContext } from '../../provider-dashboard.context'

import * as Styles from './invoices-chart-card.styles'

export const InvoicesChartCard = () => {
  const { dashboardData, actions } = useContext(ProviderDashboardContext)

  useEffect(() => {
    actions.fetchDashboardData()
  }, [])

  const percent = dashboardData?.completeInvoicesPercentage?.value ?? 0

  const color = useMemo(() => {
    if (percent < 50) {
      return 'error'
    }
    if (percent < 80) {
      return 'warning'
    }

    return 'lilac'
  }, [percent])

  const theme = useTheme()

  return (
    <Styles.Card alignItems="stretch" flexWrap="wrap">
      <Box alignItems="center">
        <DoughnutChart
          parts={[
            {
              value: dashboardData?.completeInvoicesQuantitySum?.value ?? 0,
              color: getThemeColor(color, theme),
            },
          ]}
          totalValue={parseFloat(
            (dashboardData?.invoicesQuantitySum?.value ?? 0).toString(),
          )}
          size={230}
        />
      </Box>
      <Box flex={1} direction="column" gap={2}>
        <Box gap={2} alignItems="center">
          <Styles.IconContainer>
            <Icon name="receipt" color="light_purple" size={20} />
          </Styles.IconContainer>
          <Text fontWeight={500}>Notas Fiscais</Text>
        </Box>

        <Box gap={1} direction="column">
          <Styles.BigNumber>{`${dashboardData?.completeInvoicesPercentage?.value ?? 0}%`}</Styles.BigNumber>
          <Text size="small" color="grey_3">
            % de NFs com origem cadastradas
          </Text>
        </Box>

        <Box height="1px" width="100%" backgroundColor="grey_5" />

        <Box width="100%" gap={2} flexWrap="wrap">
          <Box direction="column" minWidth="100px">
            <Styles.MediumNumber>
              {dashboardData?.completeInvoicesQuantitySum?.value ?? 0}
            </Styles.MediumNumber>
            <Text size="small" color="grey_3">
              NFs Cadastradas
            </Text>
          </Box>
          <Box direction="column" minWidth="100px">
            <Styles.MediumNumber>
              {dashboardData?.pendingInvoicesQuantitySum?.value ?? 0}
            </Styles.MediumNumber>
            <Text size="small" color="grey_3">
              NFs Pendentes
            </Text>
          </Box>
        </Box>
      </Box>

      <Box width="100%" gap={2} marginTop={1} flexWrap="wrap">
        <Box gap={1}>
          <Styles.ColoredBox color="lilac" />
          <Text size="small">{`Bom (≥ 80%)`}</Text>
        </Box>
        <Box gap={1}>
          <Styles.ColoredBox color="warning" />
          <Text size="small">{`Razoável (≥ 50%)`}</Text>
        </Box>
        <Box gap={1}>
          <Styles.ColoredBox color="error" />
          <Text size="small">{`Ruim (< 50%)`}</Text>
        </Box>
      </Box>
    </Styles.Card>
  )
}
